// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__QRboI","sm":"Avatar_sm__FYN+4","md":"Avatar_md__7cpqa","lg":"Avatar_lg__D5n0d","img":"Avatar_img__lYvl7","initials":"Avatar_initials__UChXY"};